import {
  PartnerSchoolSecondaryInfo,
  ConfirmationModal,
  AddEditPartnerSchoolModal,
  ErrorModal,
} from "components/reusables";
import { CuratedOrganization } from "models";
import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { useHistory } from "react-router-dom";
import genericAvatar from "assets/images/generic_avatar.jpg";
import { deleteSchoolStory } from "services/partnerSchoolService";

interface PartnerSchoolCardProps {
  partnerSchool: CuratedOrganization;
}

export function PartnerSchoolCard({ partnerSchool }: PartnerSchoolCardProps): JSX.Element {
  const [isShowingConfirmDelete, setIsShowingConfirmDelete] = useState(false);
  const [isShowingNewPartnerSchoolModal, setIsShowingNewPartnerSchoolModal] = useState(false);
  const [isDisplaying] = useState(partnerSchool.display);
  const [error] = useState<Error | undefined>(undefined);
  const history = useHistory();
  return (
    <>
      <Row>
        <Col xs="auto" className="d-flex align-items-center p-0" />
        <Col>
          <Card style={{ opacity: isDisplaying ? 1 : 0.5 }}>
            <Card.Body>
              <Row>
                <Col xs={3} md={2} className="d-flex align-items-center">
                  <div className="img-square-container">
                    <Img
                      src={partnerSchool.photoUrl || ""}
                      placeholder={genericAvatar}
                      alt={`${partnerSchool.organization}`}
                      width="100%"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col className="d-flex align-items-center">
                  <div>
                    <h2>{`${partnerSchool.schoolName}`} </h2>
                    <PartnerSchoolSecondaryInfo partnerSchool={partnerSchool} />
                  </div>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                  <div className="d-flex flex-column justify-content-center">
                    <Button
                      onClick={() =>
                        history.push(`map-view-admin/partner-school-details/${partnerSchool.id}`)
                      }
                      className="p-3"
                      variant="link"
                      size="lg"
                    >
                      Learn More
                      <i className="ml-2 fas fa-arrow-right" />
                    </Button>
                    <div className="buttons spaced-children">
                      <div className="buttons spaced-children">
                        <Button
                          variant="outline-success"
                          size="lg"
                          onClick={() => setIsShowingNewPartnerSchoolModal(true)}
                        >
                          Edit
                        </Button>
                      </div>
                      <Button
                        variant="outline-danger"
                        size="lg"
                        onClick={() => setIsShowingConfirmDelete(true)}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmationModal
        title="Delete Member Profile?"
        message="Are you sure you want to delete this department member profile? This action cannot be undone."
        confirmText="Delete"
        variant="danger"
        show={isShowingConfirmDelete}
        onConfirm={() => {
          return deleteSchoolStory(partnerSchool.id).finally(() => {
            window.location.reload();
          });
        }}
        onHide={() => setIsShowingConfirmDelete(false)}
      />
      <AddEditPartnerSchoolModal
        show={isShowingNewPartnerSchoolModal}
        setShow={setIsShowingNewPartnerSchoolModal}
        /*  onCancel={() => {
            history.push("map");
            history.push("map-view-admin");
            setIsShowingNewPartnerSchoolModal(false);
          }} */
        currentPartnerSchool={partnerSchool}
      />
      <ErrorModal error={error} />
    </>
  );
}
